module.exports = __webpack_public_path__ + "img/38705-075.ef3ee40c.jpg";